<template>
  <span>
    <div class="filter-shadow-wrap">
      <nav class="floating">
        <div class="top-container">
          <div class="column c4 push-right">
            <router-link to="/about">ABOUT US</router-link>
            <router-link to="/submission">SUBMISSIONS</router-link>
            <router-link to="/contact">CONTACT US</router-link>
          </div>
        </div>
        <div class="nav-container centered">
          <ul>
            <li class="menu-item">
              <router-link to="/music">MUSIC</router-link>
            </li>
            <li class="menu-item">
              <router-link to="/artists">ARTISTS</router-link>
            </li>
            <li class="menu-item">
              <router-link to="/videos">VIDEOS</router-link>
            </li>

            <li class="centered-logo"><router-link to="/"></router-link></li>

            <li class="menu-item">
              <router-link to="/podcast">PODCAST</router-link>
            </li>
            <li class="menu-item">
              <router-link to="/contest">CONTEST</router-link>
            </li>
            <li class="menu-item">
              <router-link to="/booking">BOOKINGS</router-link>
            </li>
            <li class="hamburger">
              <a @click="isShow = !isShow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  preserveAspectRatio="none"
                >
                  <g data-name="Layer 2">
                    <g data-name="menu-2">
                      <rect
                        width="24"
                        height="24"
                        transform="rotate(180 12 12)"
                        opacity="0"
                      />
                      <circle cx="4" cy="12" r="1" />
                      <rect
                        x="7"
                        y="11"
                        width="14"
                        height="2"
                        rx=".94"
                        ry=".94"
                      />
                      <rect
                        x="3"
                        y="16"
                        width="18"
                        height="2"
                        rx=".94"
                        ry=".94"
                      />
                      <rect
                        x="3"
                        y="6"
                        width="18"
                        height="2"
                        rx=".94"
                        ry=".94"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <transition name="fade">
      <div class="overlay-menu" v-show="isShow">
        <i class="far fa-times-circle" @click="isShow = !isShow"></i>
        <router-link to="/music"
          ><span @click="isShow = !isShow">MUSIC</span></router-link
        >
        <router-link to="/artists"
          ><span @click="isShow = !isShow">ARTISTS</span></router-link
        >
        <router-link to="/videos"
          ><span @click="isShow = !isShow">VIDEOS</span></router-link
        >
        <router-link to="/podcast"
          ><span @click="isShow = !isShow">PODCAST</span></router-link
        >
        <router-link to="/contest"
          ><span @click="isShow = !isShow">CONTEST</span></router-link
        >
        <router-link to="/booking">
        <span @click="isShow = !isShow">BOOKINGS</span></router-link
        >
        <hr>
        <router-link to="/about"><span @click="isShow = !isShow">ABOUT US</span></router-link>
        <router-link to="/submission"><span @click="isShow = !isShow">SUBMISSIONS</span></router-link>
        <router-link to="/contact"><span @click="isShow = !isShow">CONTACT US</span></router-link>
      </div>
    </transition>
  </span>
</template>
<script>
export default {
  name: 'homepage',
  data: function () {
    return {
      isShow: false
    }
  },

  props: {
    msg: String
  }
}
</script>

<style scoped>
.menu-item {
  width: 90px;
}
.menu-item:hover {
  background-color: var(--primary);
}

.overlay-menu {
  position: fixed;
  z-index: 10000000000;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--primary);
  opacity: 0.95;
  padding-top: 80px;
}
.overlay-menu i {
  position: fixed;
  right: 32px;
  top: 30px;
  font-size: 18px;
}
.overlay-menu a {
  display: block;
  padding: 10px;
  padding-bottom: 0px;
  font-weight: 800;
  font-size: 22px;
  width: 100%;
  text-align: right;
  padding-right: 32px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue